export default "__VITE_ASSET__e7b7ab05__"